<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iotdm/gateway/page" getKey="rows"
      :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wangguanSN')">
            <el-input v-model="yt.conditions.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wulianka')">
            <!-- <yi_data_select multiple :type="'customer'" :ids.sync="yt.conditions.customerIds"></yi_data_select> -->
            <yi_cross_select :max="1" :component="'admin_iotdm_card_list'"
                :ids.sync="yt.conditions.cardId" :isInput="true">
            </yi_cross_select>
          </el-form-item>
          <!-- 搜索框按钮 -->
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
              plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({orderBy:'createTime desc'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
          {{$t('xinzeng')}}
        </el-button>
        <el-button size="mini" @click="show = !show" plain>
          {{$t('daoru')}}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
            </el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>

      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
              @click="yt.remove(scope.row,'/web/iotdm/gateway/delete')">{{$t('shanchu')}}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('wangguanSN')" class="noborder" required>
            <el-input v-model="yt.editObj.sn">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('pingtai')" required>
            <yi_dictionary_select :type="'IOTDM_GATEWAY_PLATFORM'" :ids.sync="yt.editObj.platform">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('changshang')" required>
            <yi_dictionary_select :type="'IOTDM_GATEWAY_MANUFACTURER'" :ids.sync="yt.editObj.manufacturer">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('wulianka')">
            <!-- <yi_data_select multiple :type="'customer'" :ids.sync="yt.conditions.customerIds"></yi_data_select> -->
            <yi_cross_select :max="1" :component="'admin_iotdm_card_list'"
              :ids.sync="yt.editObj.cardId" :isInput="true">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('xinghao')" class="noborder">
            <el-input v-model="yt.editObj.model">
            </el-input>
          </el-form-item>

        </el-form>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" @click="yt.req('POST','/web/iotdm/gateway/create')" type="primary">
            {{$t('baocun')}}
          </el-button>
        </template>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('wangguanSN')" class="noborder" required>
            <el-input disabled v-model="yt.editObj.sn">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('pingtai')" required>
            <yi_dictionary_select :type="'IOTDM_GATEWAY_PLATFORM'" :ids.sync="yt.editObj.platform">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('changshang')" required>
            <yi_dictionary_select :type="'IOTDM_GATEWAY_MANUFACTURER'" :ids.sync="yt.editObj.manufacturer">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('wulianka')">
            <!-- <yi_data_select multiple :type="'customer'" :ids.sync="yt.conditions.customerIds"></yi_data_select> -->
            <yi_cross_select :max="1" :component="'admin_iotdm_card_list'" :ids.sync="yt.editObj.cardId" :isInput="true">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('xinghao')" class="noborder">
            <el-input v-model="yt.editObj.model">
            </el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" @click="yt.req('POST','/web/iotdm/gateway/update')" type="primary">
            {{$t('baocun')}}
          </el-button>

        </span>
      </template>
    </el-dialog>

    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
	import importExcel from '@@/pages/admin/iotdm/gateway/import_excel'

	export default {
		name: 'admin_iotdm_gateway_list',
		components: {
			importExcel
		},
		data() {
			return {
				list: [],
				show: false,
				columns: [{
          label: 'wangguanSN',
          prop: 'sn',
        }, {
          label: 'wulianka',
          prop: 'card.iccid'
        },{
          label: 'pingtai',
          prop: 'platform',
          type: 'dictionary',
          key: 'IOTDM_GATEWAY_PLATFORM'
        }, {
          label: 'changshang',
          prop: 'manufacturer',
          type: 'dictionary',
          key: 'IOTDM_GATEWAY_MANUFACTURER'
        },{
          label: 'xinghao',
          prop: 'model'
        },  {
					label: 'caozuo',
					type: 'slot',
					width: 180,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy:'createTime desc',
				}
        this.yt.SELECT_URL = "/web/iotdm/gateway/getGatewayByIds"
        this.yt.SELECT_RESULT_KEY = "data"
        this.yt.SELECT_ID = "id"
        this.yt.SELECT_TITLE = "sn"
				this.yt.get(1);
				this.utils.event_hub.$on('IOTDM_GATEWAY_REFRESH', () => {
					this.yt.get();
				})
			}, 300)
		},

		methods: {}
	};
</script>
